import { isProductionEnv } from '@ourbranch/env-helpers';

/**
 * Brand feature flags that can differ between production and every other environment carry two
 * booleans, `{ enabledInNonProd, enabledInProd }`, so a brand can run a feature in dev/staging
 * while it stays off in production. A missing flag is off.
 */
export const resolveEnvScopedFlag = (flag, isProd) => {
  if (!flag) {
    return false;
  }
  return isProd ? Boolean(flag.enabledInProd) : Boolean(flag.enabledInNonProd);
};

export const isEnvScopedFlagEnabled = (flag) =>
  resolveEnvScopedFlag(flag, isProductionEnv(import.meta.env?.VITE_STACKERY_ENVIRONMENT));
